import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const t = (key) => i18n.t(`settings.attention.survey.${key}`);

const QueueSurveyTable = ({ refreshKey, onConfigure }) => {
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get("/satisfaction-survey/queues")
      .then(({ data }) => active && setQueues(Array.isArray(data) ? data : []))
      .catch(toastError)
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [refreshKey]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={22} />
      </Box>
    );
  }

  if (queues.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("queueTable.empty")}
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{t("queueTable.queue")}</TableCell>
          <TableCell align="center">{t("queueTable.sends")}</TableCell>
          <TableCell align="center">{t("queueTable.settings")}</TableCell>
          <TableCell align="right" />
        </TableRow>
      </TableHead>
      <TableBody>
        {queues.map((queue) => (
          <TableRow key={queue.id} hover>
            <TableCell>{queue.name}</TableCell>
            <TableCell align="center">
              <Chip
                size="small"
                color={queue.ratingEnabled ? "success" : "default"}
                label={queue.ratingEnabled ? t("queueTable.yes") : t("queueTable.no")}
              />
            </TableCell>
            <TableCell align="center">
              <Typography variant="body2" color="text.secondary">
                {queue.customized ? t("queueTable.customized") : t("queueTable.defaults")}
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Button size="small" startIcon={<TuneOutlinedIcon />} onClick={() => onConfigure(queue)}>
                {t("configure")}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default QueueSurveyTable;
